import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { State, UpdateTagStatus } from "../../types";

export interface NotificationState {
  updateTagStatus: UpdateTagStatus[];
}

export const notificationSlice = createSlice({
  name: "notification",
  initialState: {
    updateTagStatus: [],
  } as NotificationState,
  reducers: {
    addNotification: (state, action) => {
      state.updateTagStatus.push([] as any);
      // state.updateTagStatus.push(action.payload);
    },

    removeNotification: (state, action) => {
      // state.updateTagStatus = state.updateTagStatus.filter(
      //   (item) => item.tag_code !== action.payload.tag_code
      // );
    },
  },
});

export const fetchUpdateTagStatus = createAsyncThunk(
  "notification/updateTagStatus",
  async (_, { dispatch }) => {
    // const eventSource = new EventSource(`${BASE_WORKFLOW_URL_V2}/notifications`);
    // eventSource.addEventListener(UpdateTagStatusEnum.TAG_STATUS_CHANGE_DISPATCH, (event: any) => {
    //   const eventData: UpdateTagStatus = JSON.parse(event.data);
    //   dispatch(notificationSlice.actions.addNotification(eventData));
    // });
    // eventSource.addEventListener(UpdateTagStatusEnum.TAG_STATUS_CHANGE, (event: any) => {
    //   const eventData: UpdateTagStatus = JSON.parse(event.data);
    //   dispatch(notificationSlice.actions.removeNotification({ tag_code: eventData.tag_code }));
    // });
  },
);

export const updateTagStatusSelector = (state: State) =>
  state.notification.updateTagStatus;

export const thunks = {
  fetchUpdateTagStatus,
};

export const actions = {
  ...notificationSlice.actions,
  updateTagStatusSelector,
  fetchUpdateTagStatus,
};
